import { render, staticRenderFns } from "./RelationMap.vue?vue&type=template&id=16cced73"
import script from "./RelationMap.vue?vue&type=script&lang=js"
export * from "./RelationMap.vue?vue&type=script&lang=js"
import style0 from "./RelationMap.vue?vue&type=style&index=0&id=16cced73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports